module.exports = __webpack_public_path__ + "static/media/logo.89f1df9a.png";